import { inject } from 'mobx-react';
import { observer } from 'mobx-react';
import React, { RefObject } from 'react';
import { withTheme } from 'styled-components';
import Icon from 'src/Components/Icon';
import { translate } from 'src/Components/Translate';
import { Theme } from 'src/models/Theme';
import { TranslationStore, AccessibilityStore } from 'src/stores';
import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const Input = styled<any, any>('input', 'input', 'filterSearch')`
    flex: 1;
    border: none;
    outline: none;
    font: inherit;
    background-color: transparent;
    overflow: hidden;
    &::-ms-clear {
        display: none;
    }
`;

const SearchInput = styled<any, any>('div', 'searchInput', 'filterSearch')`
    ${propStyles};
`;

SearchInput.defaultProps = {
    display: 'flex',
    flex: '1 0 auto',
    fontSize: 'inherit',
    fontFamily: 'body',
    fontWeight: 'normal',
    paddingX: 'sm',
    paddingY: 'sm',
    marginY: 'sm',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
};

const ClearSearch = styled<any, any>('button', 'clearSearch', 'filterSearch')`
    ${propStyles};
    cursor: pointer;
    outline: none;
`;

ClearSearch.defaultProps = {
    color: 'inherit',
    bgColor: 'transparent',
    borderStyle: 'none',
};

const ClearIcon = styled<any, any>(Icon, 'clearIcon', 'filterSearch')``;

ClearIcon.defaultProps = {
    cursor: 'pointer',
    height: '1em',
    width: '1em',
};

interface FilterSearchProps {
    theme?: Theme;
    forwardedRef?: RefObject<HTMLInputElement>;
    id?: string;
    translationStore?: TranslationStore;
    accessibilityStore?: AccessibilityStore;
    type?: string;
    placeholder?: string;
    value?: string;
    onChange?: () => void;
    onFocus?: () => void;
    onKeyDown?: () => void;
    onClear?: () => void;
    onClearKeyDown?: () => void;
    showClear?: boolean;
}

@inject('translationStore')
@inject('accessibilityStore')
@observer
class FilterSearch extends React.Component<FilterSearchProps> {
    render() {
        const {
            id,
            theme,
            translationStore,
            accessibilityStore,
            placeholder,
            value,
            onChange,
            onFocus,
            onKeyDown,
            onClear,
            onClearKeyDown,
            showClear,
            forwardedRef,
            ...props
        } = this.props;

        return (
            <SearchInput {...theme.FilterSearch} {...props}>
                <Input
                    ref={forwardedRef}
                    id={id}
                    type="text"
                    autoCapitalize="off"
                    autoComplete="off"
                    spellCheck="false"
                    autoCorrect="off"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onFocus={onFocus}
                    onKeyDown={onKeyDown}
                    data-metric-id={'filterSearch'}
                />
                {showClear && (
                    <ClearSearch
                        tabIndex={0}
                        aria-label={accessibilityStore.buttonAccessibilityValue(
                            'ClearSearch'
                        )}
                        title={translate(translationStore, 'Clear Search')}
                        onClick={onClear}
                        onKeyDown={onClearKeyDown}
                        data-metric-id={'filterSearch-clear'}
                    >
                        <ClearIcon fileName="CloseIcon" />
                    </ClearSearch>
                )}
            </SearchInput>
        );
    }
}

const RawFilterSearchWithRef = React.forwardRef(
    (props, ref: RefObject<HTMLInputElement>) => {
        return <FilterSearch {...props} forwardedRef={ref} />;
    }
);

export const FilterSearchWithRef = withTheme(RawFilterSearchWithRef);

export default withTheme(FilterSearch) as any;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/Filter/FilterSearch.tsx